import { AUTH_FAILED } from './types';
import { AUTH_ERROR_MESSAGES as errors } from '../utils/const';
import { createBrowserHistory } from 'history';
import { createNotification } from '../components/notifications/notifications';

const history = createBrowserHistory();

const requestMiddleware = store => next => (action) => {
  if (action.response && action.response instanceof Response) {
    if (action.response.status === 401) {
      store.dispatch({ type: AUTH_FAILED });
    } else if (action.response.status === 403) {
      createNotification('error', 'Недостаточно прав для выполнения данной операции');
    } else if (action.response.status === 503) {
      history.push('/service_temporarily_unavailable');
    } 
  }
  return next(action);
};

export default requestMiddleware;